@if (ortsunabhaengigActive$ | async) {
  <div class="form-check" id="ortsunabhaengig">
    <input
      (change)="toggleStatus($event)"
      [checked]="(status$ | async) ? ' checked' : ''"
      class="now-toggle"
      id="toggle-ortsunabhaengig"
      type="checkbox"
    />
    <label for="toggle-ortsunabhaengig" id="toggle-ortsunabhaengig-label"
      >orts&shy;unabhängig</label
    >
  </div>
}
